import React, { useState } from 'react';

import css from './articleProse.module.css';

// Q&A accordion matching the category FAQ on the /s pages (CategorySeoSection).
// Collapsed answers stay in the DOM, so crawlers read the full text server-side.
const ArticleFaq = ({ faq }) => {
  const [openItems, setOpenItems] = useState({});
  const toggle = id => setOpenItems(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <div>
      {faq.map((item, i) => (
        <div key={item.question} className={css.faqItem}>
          <button
            type="button"
            className={css.faqTrigger}
            onClick={() => toggle(i)}
            aria-expanded={!!openItems[i]}
            aria-controls={`article-faq-panel-${i}`}
            id={`article-faq-trigger-${i}`}
          >
            <h3 className={css.faqQuestion}>{item.question}</h3>
            <span
              className={`${css.faqToggleIcon} ${openItems[i] ? css.faqToggleIconOpen : ''}`}
              aria-hidden="true"
            />
          </button>
          <div
            className={`${css.faqPanelWrap} ${openItems[i] ? css.faqPanelOpen : ''}`}
            id={`article-faq-panel-${i}`}
            role="region"
            aria-labelledby={`article-faq-trigger-${i}`}
          >
            <div className={css.faqPanel}>
              <p className={css.faqAnswer}>{item.answer}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ArticleFaq;
